/* Staska Direction B — motion layer.
   Progressive enhancement: without JS (or with prefers-reduced-motion) the page is fully
   static and visible. Reveals sections as they enter the viewport with a small sibling
   stagger. (Icon line-draw removed 2026-07-08 — mid-draw it read as broken "dots in the
   shapes" on slower loads; icons must always render complete.) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.staska-pagehead .sk-wrap > *',
    '.sk-hero-copy > *',
    '.sk-hero-grid > .sk-order-panel',
    '.sk-stat',
    '.sk-value-col',
    '.sk-cat',
    '.sk-facility-grid > *',
    '.staska-compliance .sk-wrap > *',
    '.sk-cta-inner > *',
    '.page-content > h2',
    '.page-content > h3',
    '.page-content > p',
    '.page-content > ul',
    '.page-content > .sk-ap-chips',
    '.page-content > .sk-ap-ctarow',
    '.sk-ap-steps > li',
    '.sk-ap-elig-card',
    '.sk-ap-check',
    '.sk-cmp',
    '.sk-job',
    '.staska-applyform .sk-wrap > *'
  ].join(',');

  var els = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
  var counts = new Map();

  els.forEach(function (el) {
    el.classList.add('sk-reveal');
    var parent = el.parentElement;
    var n = counts.get(parent) || 0;
    counts.set(parent, n + 1);
    var delay = Math.min(n * 90, 450);
    el.style.setProperty('--skr-delay', delay + 'ms');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sk-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  els.forEach(function (el) { io.observe(el); });

  // watchdog: if reveals ever stall (background tab at load, throttled frames,
  // IO edge cases), force-reveal anything already within the viewport
  function forceRevealVisible() {
    els.forEach(function (el) {
      if (!el.classList.contains('sk-in')) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('sk-in');
      }
    });
  }
  setTimeout(forceRevealVisible, 4000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) setTimeout(forceRevealVisible, 800);
  });
})();
